<template>
  <TrialModalV2
    v-if="$hasFeatureFlag($featureFlags.fairUseChanges)"
    v-bind="$attrs"
    :data-test-id="$testId('trialModalV2')"
  />
  <TrialModalV1
    v-else
    v-bind="$attrs"
    :data-test-id="$testId('trialModalV1')"
  />
</template>

<script>
import TrialModalV1 from 'client/components/Modal/TrialModal/TrialModalV1.vue';
import TrialModalV2 from 'client/components/Modal/TrialModal/TrialModalV2.vue';

export default {
  name: 'TrialModal',

  components: {
    TrialModalV1,
    TrialModalV2,
  },
};
</script>
